import { Vector3 } from 'three';

import { Vector3 } from 'three';

export function updatePointLightPosition(
  light,
  entity,
  sunEntity,
  camera
) {
  const camToSunDist = camera.position.distanceTo(sunEntity.mesh.position);
  if (camToSunDist > 10000) return;
  
  const origDist = entity.orbitRadius;
  const newDist  = entity.distShadow * entity.size;
  const factor   = Math.pow(newDist / origDist, 0.01);
  const newInt   = 2.5 * factor;

  const dirToSun = new Vector3()
    .subVectors(sunEntity.mesh.position, entity.mesh.position)
    .normalize();
  const offset = dirToSun.multiplyScalar(newDist);
  const newPos = new Vector3().copy(entity.mesh.position).add(offset);

  light.target.position.copy(entity.mesh.position);
  light.intensity = newInt;
  light.position.copy(newPos);
  light.target.updateMatrixWorld();
}
